module.exports = __webpack_public_path__ + "img/header.17c64539.png";